import React from 'react';
import { Box } from '@mui/material';
import { ESTADO_ERROR, FUENTE, RADIO_CAMPO } from '../styles/tokensAU';

// Error para la persona en el rojo suave de la app: el mensaje claro y, si hay, un código de
// referencia corto que puede citarle a Agustín ("me salió FLOW_CLIENTE_ERROR"). Nunca el texto
// crudo de Flow.
const ErrorConCodigo = ({ mensaje, codigo, sx }) => (
  <Box
    role="alert"
    sx={[
      {
        bgcolor: ESTADO_ERROR.fondo,
        border: `1px solid ${ESTADO_ERROR.borde}`,
        color: ESTADO_ERROR.texto,
        borderRadius: RADIO_CAMPO,
        px: 2,
        py: 1.5,
        fontFamily: FUENTE,
        fontSize: 14,
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {mensaje}
    {codigo && (
      <Box component="p" sx={{ m: 0, mt: 1, fontSize: 12, opacity: 0.85 }}>
        Código de referencia: {codigo}
      </Box>
    )}
  </Box>
);

export default ErrorConCodigo;
